

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interface Overallperformance {
// courses : any,
// teacher_id : any,
// students :any,
// }

interface EventOverview {
    students: any[];
    courses: any[];
    teacher_id: string;
    type: any;
    year: any;
    month: any;
    month_year: any,
    start_date: any,
    end_date: any


}

const initialState: EventOverview = {
    courses: [],
    students: [],
    teacher_id: "",
    type: "",
    year: "",
    month: "",
    month_year: "",
    start_date: "",
    end_date: ""

};


const eventOverviewByTeacherSlice = createSlice({
    name: "eventOverviewByTeacher",
    initialState,
    reducers: {


        setEventData: (state: EventOverview, action: PayloadAction<any[]>) => {
            state.students = action.payload;

            // console.log("act",action);


            // state.isLoading = false;
            // state.error = null;
        },
        // setPagination: (state: CourseState, action: PayloadAction<CourseState>) => {
        //     state.next = action.payload.next;
        //     state.previous = action.payload.previous;
        //     state.count = action.payload.count;
        //     state.totalPages = Math.ceil((action.payload.count ?? 0) / 12);
        //     state.isLoading = false;
        //     state.error = null;
        // },
        // setloading: (state: CourseState, action: PayloadAction<boolean>) => {
        //     state.isLoading = action.payload;
        //     state.error = null;
        // },
        // seterror: (state: CourseState, action: PayloadAction<string>) => {
        //     state.error = action.payload;
        //     state.isLoading = false;
        // },
        resetEventData: () => {
            return initialState;
        },
    },
});

export const {
    setEventData,
    // setloading,
    // seterror,
    // setPagination,
    resetEventData,
} = eventOverviewByTeacherSlice.actions;

export default eventOverviewByTeacherSlice.reducer;
